<script setup>
import { Head } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import PublicLayout from '@/Layouts/PublicLayout.vue'

defineOptions({ layout: PublicLayout })

const { t } = useI18n()
defineProps({
  types: { type: Array, default: () => [] },
  partners_base: { type: String, default: 'https://partners.getphuket.com' }
})

const steps = ['create', 'verify', 'list']
</script>

<template>
  <Head>
    <title>{{ t('public.partners.head_title') }}</title>
    <meta
      name="description"
      :content="t('public.partners.head_description')"
    >
  </Head>

  <section class="pp">
    <header class="pp__hero">
      <h1 class="pp__title">
        {{ t('public.partners.title') }}
      </h1>
      <p class="pp__lede">
        {{ t('public.partners.lede') }}
      </p>
    </header>

    <div class="pp__grid">
      <article
        v-for="ty in types"
        :key="ty"
        class="pp__card"
      >
        <h2 class="pp__card-title">
          {{ t(`public.partners.types.${ty}.name`) }}
        </h2>
        <p class="pp__card-value">
          {{ t(`public.partners.types.${ty}.value`) }}
        </p>
        <ol class="pp__steps">
          <li
            v-for="s in steps"
            :key="s"
          >
            {{ t(`public.partners.steps.${s}`) }}
          </li>
        </ol>
        <a
          :href="`${partners_base}/register?type=${ty}`"
          class="pp__cta"
        >
          {{ t('public.partners.cta', { type: t(`public.partners.types.${ty}.name`) }) }}
        </a>
      </article>
    </div>
  </section>
</template>

<style scoped>
.pp { max-width: 64rem; margin: 0 auto; padding: 2.5rem 1.5rem 4rem; }
.pp__hero { text-align: center; max-width: 40rem; margin: 0 auto 2.5rem; }
.pp__title { font-family: var(--font-display, var(--display)); font-size: clamp(1.875rem, 5vw, 2.5rem); margin: 0 0 0.75rem; color: var(--ink); font-weight: 700; }
.pp__lede { color: var(--inkSoft); font-size: 1.0625rem; line-height: 1.6; margin: 0; }
.pp__grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr)); gap: 1rem; }
.pp__card { display: flex; flex-direction: column; padding: 1.25rem; background: var(--surface); border: 1px solid var(--line); border-radius: 0.875rem; }
.pp__card-title { margin: 0 0 0.4rem; font-size: 1.125rem; font-weight: 700; color: var(--ink); }
.pp__card-value { margin: 0 0 0.875rem; font-size: 0.9375rem; color: var(--inkSoft); line-height: 1.5; }
.pp__steps { margin: 0 0 1.25rem; padding-left: 1.1rem; color: var(--inkSoft); font-size: 0.875rem; display: grid; gap: 0.3rem; }
.pp__cta { margin-top: auto; display: inline-block; text-align: center; padding: 0.6rem 1rem; border-radius: var(--radius-button, 8px); background: var(--accent); color: var(--accentInk); font-weight: 600; text-decoration: none; }
.pp__cta:hover { filter: brightness(0.97); }
</style>
